import { render, staticRenderFns } from "./ListarMarca.vue?vue&type=template&id=5d5b152a"
import script from "./ListarMarca.vue?vue&type=script&lang=js"
export * from "./ListarMarca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports